<div class="dialog-content">
  <div class="confirmation-title" *ngIf="data.title" [innerHTML]="data.title"></div>
  <div class="confirmation-text" *ngIf="data.text">
    {{data.text}}
  </div>
</div>

<div class="buttons-row df gap20 ai-c jc-c">
  <button class="default-button cancel-button" [mat-dialog-close]="true" *ngIf="data.cancelText" (click)="closeDialog(false)">
    {{data.cancelText ? (data.cancelText | translate) : ''}}
  </button>
  <button class="default-button apply-button" (click)="closeDialog(true)" *ngIf="data.submitText">
    {{data.submitText ? (data.submitText | translate) : ''}}
  </button>
</div>
